import { connect } from 'react-redux'
import GroupsModalFooter from './groups-modal-footer'
import {
  hideFilterDialog,
  applyGroupsFilter
} from '../../pupils-component-redux/pupils-component.actions'

const mapDispatchToProps = (dispatch, { selectedGroups }) => ({
  onCancel: () => dispatch(hideFilterDialog()),
  onSubmit: () => dispatch(applyGroupsFilter(selectedGroups))
})

export default connect(
  null,
  mapDispatchToProps
)(GroupsModalFooter)
